import React from 'react'


const Password = props => {
    return<>
        <p>****33ts</p>
     </>
}



export default Password;